import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Daily.css'; // Reutilizamos los estilos de Daily para mantener la consistencia
import slide1 from '../assets/Daily1.avif'; // Usamos imágenes existentes como base
import slide2 from '../assets/Daily2.avif';
import { ShoppingBag, Store } from 'lucide-react';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const SellOut = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isMobile) {
      navigate('/daily', { replace: true });
    }
  }, [navigate]);

  return (
    <motion.div 
      className="dashboard-container"
      initial={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      animate={isMobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
      exit={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={isMobile ? { duration: 0 } : { duration: 0.5 }}
    >
      <div className="title-section">
        <h1 className="dailymenu">Gestión de Canales</h1>
        <div className="title-underline-daily"></div>
        <h1 className="subtitle-daily">Sell Out Report</h1>
      </div>

      <div className="daily-menu-grid">
          {/* Card 1: Canal Moderno */}
          <div className="daily-card" onClick={() => navigate('/sellout-moderno')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide1})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <ShoppingBag size={28} color="white" />
              </div>
              <h3>Canal Moderno</h3>
              <p>Supermercados, Cadenas y Grandes Superficies.</p>
            </div>
          </div>

          {/* Card 2: Canal Tradicional */}
          <div className="daily-card" onClick={() => navigate('/sellout-tradicional')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide2})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Store size={28} color="white" />
              </div>
              <h3>Canal Tradicional</h3>
              <p>Mayoristas, Minoristas y Distribuidores.</p>
            </div>
          </div>
      </div>
    </motion.div>
  );
};

export default SellOut;
